class SendEmailNowViewModel {
    email: KnockoutObservable<string>;
    subject: KnockoutObservable<string>;
    body: KnockoutObservable<string>;
    format: KnockoutObservable<EmailFormatEnum>;
    pdfTemplate: KnockoutObservable<number>;
    suppressReportHeader: KnockoutObservable<boolean>;

    constructor() {
        this.email = ko.observable(loggedUser.email());
        this.format = ko.observable(EmailFormatEnum.PDF);

        this.subject = ko.observable("");
        this.body = ko.observable("");
        this.pdfTemplate = ko.observable(0);
        this.suppressReportHeader = ko.observable(false);
    }

    //reset(isWorkbook: boolean, isDashboard: boolean, tab: WorkbookTab) {
    //    this.email(loggedUser.email());
    //    this.format(SendEmailNowViewModel.getFormatDataSource(isWorkbook, isDashboard, tab).find(x => x.visible)?.id);
    //    this.subject("");
    //    this.body("");
    //    this.pdfTemplate(0);
    //}

    static getFormatDataSource(isWorkbook: boolean, isDashboard: boolean, tab: WorkbookTab) {
        return [
            { id: EmailFormatEnum.PDF, name: "PDF", visible: loggedUser.permissions.printExportPDF() },
            { id: EmailFormatEnum.PDFLandscape, name: "PDF Landscape", visible: loggedUser.permissions.printExportPDF() },
            { id: EmailFormatEnum.Excel, name: "XLSX", visible: !isWorkbook && !isDashboard && loggedUser.permissions.exportExcelCSV() },
            { id: EmailFormatEnum.ExcelWithoutHeaders, name: "Simple XLSX", visible: !isWorkbook && !isDashboard && loggedUser.permissions.exportExcelCSV() },
            { id: EmailFormatEnum.CSV, name: "CSV", visible: !isWorkbook && !isDashboard && loggedUser.permissions.exportExcelCSV() },
            { id: EmailFormatEnum.CSVWithoutHeaders, name: "Simple CSV", visible: !isWorkbook && !isDashboard && loggedUser.permissions.exportExcelCSV() },
            { id: EmailFormatEnum.Image, name: "Image", visible: !isWorkbook && loggedUser.permissions.printExportPDF() && irSettings.emailBodyHTML  },
            {
                id: EmailFormatEnum.EmailBody, name: "Email Body",
                visible: !isWorkbook && !isDashboard && loggedUser.permissions.printExportPDF() && irSettings.emailBodyHTML && tab?.drilldownManager?.activeReportConfig && tab.drilldownManager.activeReportConfig.reportType() === ReportTypeEnum.Analysis
            },
        ];
    }
}